// @flow
import { connect } from 'react-redux';

import RencontreStats from 'components/rencontre/RencontreStats';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/rencontre/RencontreStats';
import { selectCompetitionLinkOnRencontre } from 'selectors/selectSettings';

const mapStateToProps = (state: StateType): StateProps => ({
  rencontre: state.rencontreState.rencontre,
  ranking: state.rankingState.ranking,
  status: state.rankingState.status,
  competitionLink: selectCompetitionLinkOnRencontre(state),
});

export default connect(mapStateToProps)(RencontreStats);
